$(function() {
  const $body = $('body');
  // const isHome = $body.is('[coretex-page="index"]'); // trueならTOPページ

  // フッタ開閉トグル押下時
  // $(document).on('click', '[data-footer-toggle]', function(e) {
  //   const $body = $('body');
  //   const $footer = $('[data-footer]');
  //   const scrT = $(window).scrollTop();
  //   const isOpen = $('body').is('.is-open-footer');
  //   const duration = 300;
  //   if (isOpen) { // 閉じる
  //     $body.removeClass('is-open-footer');
  //     $footer.slideUp(duration);
  //   } else { // 開く
  //     $body.addClass('is-open-footer');
  //     $footer.slideDown(duration, function() {
  //       const footerH = Math.floor($footer.outerHeight());
  //       $(window).scrollTop(scrT + footerH);
  //     });
  //   }
  // });

  // 100vh 計算
  const setFillHeight = () => {
    const lvh = window.innerHeight * 0.01;
    console.log('--lvh', lvh);
    document.documentElement.style.setProperty('--lvh', `${lvh}px`);
  };

  // 画面のサイズ変動があった時に高さを再計算する
  window.addEventListener('resize', setFillHeight);

  // 初期化
  setFillHeight();

  // TOP: ヘッダロゴ表示切替｜背景透過ヘッダ切替
  const headerTransparentClassName = 'header-transparent';
  const isHeaderTransparent = $body.hasClass(headerTransparentClassName);
  const switchTopLogo = () => {
    const $headerLogo = $('[data-header-logo]');
    const $body = $('body');

    // 切替
    const headerLogoH = $headerLogo.outerHeight();
    const scrT = $(window).scrollTop();
    if (scrT >= headerLogoH) {
      $body.addClass('is-scrolled');
      $body.removeClass(headerTransparentClassName);
    } else {
      $body.removeClass('is-scrolled');
      if (isHeaderTransparent) {
        $body.addClass(headerTransparentClassName);
      }
    }
  }

  // ヘッダの背景色切替
  // const switchHeaderBgColor = () => {
  //   const $coretexHeader = $('[data-coretex-header]');
  //   if (isHome) {
  //     const scrT = $(window).scrollTop();
  //     const $fvFooter = $('[data-fv-footer]');
  //     const fvFooterOffset = $fvFooter.offset();
  //     const fvFooterB = fvFooterOffset.top + $fvFooter.outerHeight();
  //     if (scrT >= fvFooterB) {
  //       $coretexHeader.addClass('is-show-bg');
  //     } else {
  //       $coretexHeader.removeClass('is-show-bg');
  //     }
  //   } else {
  //     $coretexHeader.addClass('is-show-bg');
  //   }
  // }

  // スクロール時
  $(window).on('scroll resize load', function(e) {
    switchTopLogo();
    // switchHeaderBgColor();
  });

  // textareaのリサイズアイコンカスタマイズ
  const $textarea = $('[data-textarea-wrap] textarea');
  let isResizing = false;
  let startX, startY, startWidth, startHeight;

  // --- 開始（mousedown or touchstart） ---
  $(document).on('mousedown touchstart', '[data-textarea-wrap] [data-resize-handle]', function(e) {
    e.preventDefault();
    // console.log('check');

    const evt = e.type === 'touchstart' ? e.originalEvent.touches[0] : e;

    isResizing = true;
    startX = evt.clientX;
    startY = evt.clientY;
    startWidth = $textarea.outerWidth();
    startHeight = $textarea.outerHeight();

    $(document).on('mousemove touchmove', resize);
    $(document).on('mouseup touchend touchcancel', stopResize);
  });

  // --- リサイズ処理 ---
  function resize(e) {
    if (!isResizing) return;
    e.preventDefault();
    e.stopPropagation();

    const evt = e.type.startsWith('touch') ? e.originalEvent.touches[0] : e;
    const newWidth = startWidth + (evt.clientX - startX);
    const newHeight = startHeight + (evt.clientY - startY);

    // 最小サイズ制限（任意）
    const minWidth = 100;
    const minHeight = 78;
    const maxHeight = 600;

    $textarea.css({
      // width: Math.max(minWidth, newWidth) + 'px',
      height: Math.min(Math.max(minHeight, newHeight), maxHeight) + 'px'
    });
  }

  // --- 終了処理 ---
  function stopResize(e) {
    e.preventDefault();
    e.stopPropagation();
    isResizing = false;
    $(document).off('mousemove touchmove', resize);
    $(document).off('mouseup touchend touchcancel', stopResize);
  }

  // trigger（ホバー時は反応させないが、トリガーで発火させたい場合用）
  $(document).on('hoverSync', '[data-hover-sync-trigger]', function (e) {
    $(this).find('[data-hover-sync-child]').addClass('is-hover');
  });

  // SP: 遅延遷移
  // let touchStartX, touchStartY, maxDelta;

  // // タッチスタート時
  // $(document).on('touchstart', '[data-sp-delay-link]', function (e) {
  //   const t = e.originalEvent.touches[0];
  //   touchStartX = t.clientX;
  //   touchStartY = t.clientY;
  //   maxDelta = 0;
  // });

  // // タッチムーブ時
  // $(document).on('touchmove', '[data-sp-delay-link]', function () {
  //   const t = e.originalEvent.touches[0];
  //   const deltaX = Math.abs(t.clientX - touchStartX);
  //   const deltaY = Math.abs(t.clientY - touchStartY);
  //   maxDelta = Math.max(maxDelta, deltaX, deltaY);
  // });

  // // リンク押下時
  // $(document).on('click touchend', '[data-sp-delay-link]', function (e) {
  //   const $body = $('body');
  //   const bp = $body.data('sp-delay-link-breakpoint') || 1025;
  //   const duration = $body.data('sp-delay-link-duration') || 1000; // [ms]
  //   const winW = $(window).width();
  //   if (winW >= bp) {
  //     return; // PCでは機能しない
  //   }

  //   // リンクのチェック
  //   const href = $(this).attr('href');
  //   const target = $(this).attr('target');
  //   const closest = $(this).attr('data-delay-link-closest');
  //   if (!href || href == '' || target == '_blank') {
  //     return;
  //   }

  //   // SPのとき、scroll中でないなら処理を続行
  //   if (e.type === 'touchend') {
  //     const threshold = 10; // 許容範囲(px) この値を超えていたらスクロール中
  //     if (maxDelta > threshold) {
  //       return;
  //     }
  //   }

  //   e.preventDefault();

  //   // 指定の要素にclickedクラスを付与
  //   const $clickedElm = closest ? $(this).closest(closest) : $(this);
  //   $clickedElm.addClass('clicked is-hover');

  //   // hover-syncの連動（あれば）
  //   if ($clickedElm.is('[data-hover-sync]')) {
  //     $clickedElm.trigger('mouseenter');
  //   }
  //   if ($clickedElm.is('[data-hover-sync-trigger]')) {
  //     $clickedElm.trigger('hoverSync');
  //   }

  //   // 遅延遷移
  //   setTimeout(() => {
  //     location.href = href;
  //   }, duration);
  // });

  // *****************************************************************************
  // * メニュー
  // *****************************************************************************

  // メニュートグル押下時
  $(document).on('click', '[data-menu-toggle]', function(e) {
    const isOpenMenuClassName = 'is-open-menu';
    const $body = $('body');
    const isOpenMenu = $body.hasClass(isOpenMenuClassName);
    if (isOpenMenu) { // 開く→閉じる
      $body.removeClass(isOpenMenuClassName);
    } else { // 閉じる→開く
      $body.addClass(isOpenMenuClassName);
    }
  });

  // *****************************************************************************
  // * 汎用アコーディオン
  // *****************************************************************************
  $(document).on('click', '[data-accordion-toggle]', function (e) {
    e.stopPropagation();
    const duration = $(this).data('accordion-duration') || 300; // [ms]
    const key = $(this).attr('data-accordion-toggle');

    // コンテナ
    const $container = $(this).closest('[data-accordion-container="' + key + '"]');
    if (!$container.length) {
      return;
    }

    // 開閉状態
    const isOpen = $container.hasClass('is-open');

    // コンテンツ
    const $content = $container.find('[data-accordion-content="' + key + '"]');
    if (!$content.length) {
      return;
    }

    // スライダー再初期化
    const sliderReinit = $container.data('slider-reinit');

    // アイコン
    const $iconPlus = $(this).find('[data-icon-plus]');
    const $iconMinus = $(this).find('[data-icon-minus]');

    // オプション: 開いたとき、コンテンツ分の高さ分スクロール
    const isScrollAfterOpen = $(this).data('accordion-scroll-after-open');
    const scrT = $(window).scrollTop();

    // 開閉
    if (isOpen) { // 閉じる
      $container.removeClass('is-open');
      $iconMinus.hide(0);
      $iconPlus.show(0);
      $content.stop().slideUp(duration);
    } else { // 開く
      $container.addClass('is-open');
      $iconPlus.hide(0);
      $iconMinus.show(0);
      $content.stop().slideDown(duration, function () {
        // スライダーの再初期化
        if (sliderReinit) {
          $container.find('[data-slick]').each(function (i, slider) {
            $(slider).trigger('reinit');
          });
        }

        // コンテンツ分の高さ分スクロール（オプション）
        if (isScrollAfterOpen) {
          const contentH = Math.floor($content.outerHeight(true));
          $(window).scrollTop(scrT + contentH);
        }
      });
    }
    setTimeout(function () {
      $(window).trigger('resize'); // コンテンツ高さが変わるので
    }, duration);
  });

  // ロード時: リクエストパラメータからロード時にアコーディオンを開いた状態にする
  $(window).on('load', function(e) {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const key = params.get('open');
    const $toggle = $('[data-accordion-toggle="'+key+'"]');
    if (!key || !$toggle.length) {
      return;
    }
    const $container = $toggle.closest('[data-accordion-container="' + key + '"]');
    if (!$container.length || $container.hasClass('is-open')) {
      return;
    }

    // アコーディオン開く（開いていない場合）
    $('[data-accordion-toggle="'+key+'"]').trigger('click');
  });
  // 汎用アコーディオン end

  // *****************************************************************************
  // * FAQレンダリング
  // *****************************************************************************
  const $faqJson = $('[data-faqs-json]');
  const faqs = $faqJson.length ? JSON.parse($faqJson.text()) : [];
  const $templateFaqAccordion = $('[data-template="faq-accordion"]');
  const $faqAccordions = $('[data-accordions]');
  if ($templateFaqAccordion.length && $faqAccordions.length) {
    $faqAccordions.empty();
    $(faqs).each(function(i, faq) {
      const $faqAccordion = $($templateFaqAccordion.prop('content')).clone(true);
      $faqAccordion.find('[data-accordion-container]').attr('data-accordion-container', faq.slug);
      $faqAccordion.find('[data-accordion-toggle]').attr('data-accordion-toggle', faq.slug);
      $faqAccordion.find('[data-title-en]').text(faq.title_en);
      $faqAccordion.find('[data-title-jp]').text(faq.title_jp);
      $faqAccordion.find('[data-accordion-content]').attr('data-accordion-content', faq.slug);
      $faqAccordion.find('[data-description-jp]').text(faq.description_jp);
      $faqAccordion.find('[data-description-en]').text(faq.description_en);
      $faqAccordions.append($faqAccordion);
    });
  }

  // *****************************************************************************
  // * Finishingレンダリング
  // *****************************************************************************
  const $finishingJson = $('[data-finishings-json]');
  const finishings = $finishingJson.length ? JSON.parse($finishingJson.text()) : [];
  const $templateFinishingAccordion = $('[data-template="finishing-accordion"]');
  const $finishingAccordions = $('[data-accordions]');
  if ($templateFinishingAccordion.length && $finishingAccordions.length) {
    $finishingAccordions.empty();
    $(finishings).each(function(i, finishing) {
      const $finishingAccordion = $($templateFinishingAccordion.prop('content')).clone(true);
      $finishingAccordion.find('[data-accordion-container]').attr('data-accordion-container', finishing.slug);
      $finishingAccordion.find('[data-accordion-toggle]').attr('data-accordion-toggle', finishing.slug);
      $finishingAccordion.find('[data-title-en]').text(finishing.title_en);
      $finishingAccordion.find('[data-title-jp]').text(finishing.title_jp);
      $finishingAccordion.find('[data-accordion-content]').attr('data-accordion-content', finishing.slug);
      $finishingAccordion.find('[data-description-jp]').text(finishing.description_jp);
      $finishingAccordion.find('[data-description-en]').text(finishing.description_en);

      // 画像
      const $img = $('<img>');
      $img.attr({
        src: finishing.image_url,
        alt: finishing.title_en + ' / ' + finishing.title_jp
      });
      $finishingAccordion.find('[data-image-box]').append($img);

      $finishingAccordions.append($finishingAccordion);
    });
  }

  // *****************************************************************************
  // * お問い合わせレンダリング
  // *****************************************************************************
  const $contactJson = $('[data-contacts-json]');
  const contacts = $contactJson.length ? JSON.parse($contactJson.text()) : [];
  const $templateContactAccordion = $('[data-template="contact-accordion"]');
  const $contactAccordions = $('[data-accordions]');
  if ($templateContactAccordion.length && $contactAccordions.length) {
    $(contacts).each(function(i, contact) {
      const $contactAccordion = $($templateContactAccordion.prop('content')).clone(true);
      $contactAccordion.find('[data-accordion-container]').attr('data-accordion-container', contact.slug);
      $contactAccordion.find('[data-accordion-toggle]').attr('data-accordion-toggle', contact.slug);
      $contactAccordion.find('[data-title-en]').text(contact.title_en);
      $contactAccordion.find('[data-title-jp]').text(contact.title_jp);
      $contactAccordion.find('[data-accordion-content]').attr('data-accordion-content', contact.slug);
      $contactAccordion.find('[data-description-jp]').html(contact.description_jp);
      $contactAccordion.find('[data-description-en]').html(contact.description_en);
      $contactAccordions.append($contactAccordion);
    });
  }

  // *****************************************************************************
  // * お問い合わせ: 商品ページURLのフォームにフルパスのURLをセットする
  // *****************************************************************************
  const $urlPathInputs = $('[data-url-path]');
  $urlPathInputs.each(function(i, elm) {
    const $input = $(elm);
    const urlPath = $input.data('url-path');
    if (!urlPath.length) {
      return true; // continue
    }

    // inputがブランクならフルパスのURLをセット
    const fullUrl = location.origin+urlPath;
    if (!$input.val().length) {
      $input.val(fullUrl);
    }
  });

  // *****************************************************************************
  // * お問い合わせ送信後のアコーディオン・メッセージを活性
  // *****************************************************************************
  const hash = location.hash;
  if (hash.startsWith('#ContactForm-template--')) { // お問い合わせ
    $('[data-message-box="contact"]').show(0);
    $('[data-accordion-toggle="contact"]').trigger('click');
  } else if (hash.startsWith('#ContactForm-Quotation-template--')) { // 見積もり依頼
    $('[data-message-box="quotation"]').show(0);
    $('[data-accordion-toggle="quotation"]').trigger('click');
  }

  // *****************************************************************************
  // * 商品詳細: バリエーション選択
  // *****************************************************************************

  // トグル押下時
  $(document).on('click', '[data-variant-select-toggle]', function(e) {
    const $selectWrap = $(this).closest('[data-variant-select-wrap]');
    const $selectList = $selectWrap.find('[data-variant-select-list]');
    const isOpen = $selectWrap.hasClass('is-open');
    const duration = 300; // [ms]
    if (isOpen) { // 開く → 閉じる
      $selectWrap.removeClass('is-open');
      $selectList.stop().slideUp(duration);
    } else { // 閉じる → 開く
      $selectWrap.addClass('is-open');
      $selectList.stop().slideDown(duration);
    }
  });

  // *****************************************************************************
  // * 商品詳細: PC: 画像ギャラリー
  // *****************************************************************************

  // サムネイル押下時
  $(document).on('click', '[data-thumbnail]', function(e) {
    const duration = 300;
    const $mediaContainer = $(this).closest('[data-media-container]');
    const index = $(this).attr('data-thumbnail');
    const $targetSlidePc = $mediaContainer.find('[data-slide-pc="'+index+'"]');
    $mediaContainer.find('[data-slide-pc]').fadeOut(duration);
    $targetSlidePc.fadeIn(duration);
  });
});

// SP: 遅延遷移（改良版）
$(function () {
  let startX = 0;
  let startY = 0;
  let moved = false;
  let timer = null;  // リンク押下時

  const MOVE_THRESHOLD = 10; // 10px以上動いたらスクロール扱い

  $(document).on('pointerdown', '[data-sp-delay-link]', function (e) {
    const $body = $('body');
    const bp = $body.data('sp-delay-link-breakpoint') || 768;
    const duration = $(this).data('sp-delay-link-duration') || $body.data('sp-delay-link-duration') || 1000; // [ms]
    const winW = $(window).width();
    if (winW >= bp) return; // PCでは機能しない

    // リンクのチェック
    const href = $(this).attr('href');
    const target = $(this).attr('target');
    if (!href || href == '' || target == '_blank') return;

    startX = e.clientX;
    startY = e.clientY;
    moved = false;

    const $link = $(this);

    const onMove = function (ev) {
      const dx = Math.abs(ev.clientX - startX);
      const dy = Math.abs(ev.clientY - startY);
      if (dx > MOVE_THRESHOLD || dy > MOVE_THRESHOLD) {
        moved = true;
        clearTimeout(timer);
        $(document).off('pointermove', onMove);
      }
    };

    const onUp = function () {
      $(document).off('pointermove', onMove);
      $(document).off('pointerup', onUp);

      if (!moved) {
        e.preventDefault();
        timer = setTimeout(() => {
          location.href = href;
        }, duration);
      }
    };

    $(document).on('pointermove', onMove);
    $(document).on('pointerup', onUp);

    // // デバッグ用
    // const $tmpDebug = $('<pre>').css({
    //   position: 'fixed',
    //   right: 0,
    //   bottom: 0,
    //   zIndex: 9999,
    //   background: '#fff',
    //   color: '#000',
    //   padding: '4px 2px',
    //   overflow: 'hidden',
    //   maxHeight: '200px',
    // }).attr({'data-debug': '1'});
    // let $debug = $('[data-debug]');
    // if (!$debug.length) {
    //   $body.append($tmpDebug);
    // }
    // $debug.text($debug.text()+`before preventDefault\n===================\n`);

    // e.preventDefault();

    // // デバッグ用
    // $debug.text($debug.text()+`after preventDefault\n===================\n`);

    // 遅延遷移
    // setTimeout(() => {
    //   location.href = href;
    // }, duration);
  });
});

